<template>
    <v-container fluid style="margin: 20px; padding: 10px; width: 100%">
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>รายงาน Controller</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'
                 @onUserBranchNameChange='setCurrentBranchName'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>

            <template>
                <v-container fluid style="margin: 20px; padding: 10px; width: 100%">
                    <v-card outlined>
                        <v-card-subtitle class="pb-0">
                        <v-row>
                            <v-col><DatePicker disabled label="ข้อมูล ณ วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                            <v-col>
                                <v-select
                                    v-model="carStatus"
                                    :items=carStatusItems
                                    item-text="text"
                                    item-value="value"
                                    id="carStatus"
                                    label="สถานะรถจอด"
                                    outlined
                                >
                                </v-select>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                     <v-btn  class="ma-2" color="primary" :disabled="hideBtnReport" small @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
                                </v-row>
                            </v-col>
                            
                        </v-row>
                        </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>

         <template>
            <v-data-table 
                :items="items"
                class="pt-5"
                style="width:400%"
                >
                <template v-slot:header>
                    <thead>
                        <tr class="light-blue1-custom">
                            <th colspan="14" style="border: black;border-style: solid;border-width: 1px 0px 1px 1px"></th>
                            <th colspan="42" class="text-center border">
                                <h3><span>บอร์ดดำเนินงาน</span></h3>
                            </th>
                            <th rowspan="4" class="text-center" style="border: black;border-style: solid;border-width: 1px 1px 1px 0px">
                                หมายเหตุ
                            </th>
                        </tr>
                        <tr>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center" ><span>No.</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center" ><span>วันที่รถเข้า</span></h3>
                            </th>
                            <th rowspan="3" colspan="2" class="border-body">
                                <h3 class="text-center"><span>ประกันภัย</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>เลขที่ใบสั่งซ่อม</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center vertical-text"><span>ทะเบียน</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>รุ่นรถ</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>สีรถ</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>SA</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="vertical-text"><span>ประเภท</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center vertical-text"><span>ชิ้นงาน</span></h3>
                            </th>
                            <th rowspan="2" style="border: black;border-style: solid;border-width: 0px 0px 0px 1px">
                                <h3 class="text-center vertical-text"><span>รถไม่จอด</span></h3>
                            </th>
                            <th colspan="2" class="border-body">
                                <h3 class="text-center"><span>ค่าแรงหลังหักส่วนลด</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>วันที่นัดเสร็จ</span></h3>
                            </th>

                            <!-- board -->
                            <th rowspan="2" style="border: black;border-style: solid;border-width: 0px 0px 0px 1px">
                                <h3 class="text-center vertical-text"><span>หยุดงาน</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>หมายเหตุ <br> หยุดงาน</span></h3>
                            </th>
                            <th rowspan="3" class="border-body">
                                <h3 class="text-center"><span>เพิ่มเติม/อนุมัติ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>ปัญหางาน</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="4" class="border-body">
                                <h3 class="text-center"><span>เคาะ >>></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>เตรียมพื้น >>></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.prepareGround}}</span></h3>
                            </th>
                            <!--
                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>ผสมสี</span></h3>
                            </th>
                            
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.mixColor}}</span></h3>
                            </th>
                            -->
                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>พ่นสี</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.sprayPaint}}</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>ประกอบ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.assemble}}</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>ขัดสี</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.wax}}</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>เก็บงาน</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.clean}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>รอ</span></h3>
                            </th>
                            <th colspan="3" class="border-body">
                                <h3 class="text-center"><span>QC</span></h3>
                            </th>
                            <th class="border-close">
                                <h3 class="text-center"><span>{{sum.check}}</span></h3>
                            </th>
                        </tr>
                        <tr>
                            <th rowspan="2" class="border-body">
                                <h3 class="text-center"><span>ค่าแรงงาน</span></h3>
                            </th>
                            <th rowspan="2" class="border-body">
                                <h3 class="text-center"><span>ค่าอะไหล่</span></h3>
                            </th>
                            <th colspan="2"   style="border: black;border-style: solid;border-width: 0px 0px 0px 1px">
                                <h3 class="text-center"><span>รออนุมัติ </span></h3>
                            </th>
                            <th  style="border: black;border-style: solid;border-width: 0px 0px 0px 1px">
                                <h3 class="text-center"><span>รออะไหล่ </span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitKnock}}</span></h3>
                            </th>
                            <th colspan="2" class="border-body">
                                <h3 class="text-center"><span>เริ่ม</span></h3>
                            </th>
                            <th colspan="2" class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitPrepareGround}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <!--
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitMixColor}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            -->
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitSprayPaint}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitAssemble}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitWax}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitClean}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>{{sum.waitCheck}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                            <th class="border-close">
                                <h3 class="text-center"><span></span></h3>
                            </th>
                        </tr>

                        <tr>
                            <th style="border: black;border-style: solid;border-width: 0px 0px 1px 1px">
                                <h3 class="text-center"><span>{{sum.carNotPresent}}</span></h3>
                            </th>
                            <th style="border: black;border-style: solid;border-width: 0px 0px 1px 1px">
                                <h3 class="text-center"><span>{{sum.jobPause}}</span></h3>
                            </th>
                            <th colspan="2" style="border: black;border-style: solid;border-width: 0px 0px 1px 1px">
                                <h3 class="text-center"><span>{{sum.waitInsurance}}</span></h3>
                            </th>
                            <th style="border: black;border-style: solid;border-width: 0px 0px 1px 1px">
                                <h3 class="text-center"><span>{{sum.waitParts}}</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <!--
                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            -->
                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>

                            <th class="border-body">
                                <h3 class="text-center"><span>ช่าง</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>วันที่</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                            <th class="border-body">
                                <h3 class="text-center"><span>เสร็จ</span></h3>
                            </th>
                            <th class="border-close">
                                <h3 class="text-center"><span>เวลา</span></h3>
                            </th>
                        </tr>
                        
                    </thead>
                </template>
 <!-- Render Data -->
                <template v-slot:body="{ items }">
                    <tbody name="list" >
                        <tr v-if="items.length == 0" class="text-center">
                            <td colspan="60"> ไม่พบข้อมูล
                            </td>
                        </tr>
                        <tr v-else v-for="item in items" :key="item.transId" class="item-row">
                            <td>{{item.no}}</td>
                            <td>{{item.receiveDate}}</td>
                            <td>{{item.insurance}}</td>
                            <td>{{item.insuranceServiceType}}</td>
                            <td>{{item.jobNo}}</td>
                            <td>{{item.licenseNo}}</td>
                            <td>{{item.model}}</td>
                            <td>{{item.color}}</td>
                            <td>{{item.sa}}</td>
                            <td>{{item.jobSize}}</td>
                            <td>{{item.transCount}}</td>
                            <td>{{displayCarNotPresent(item.carNotPresent)}}</td>
                            <td>{{numberFormat(item.serviceTotal)}}</td>
                            <td>{{numberFormat(item.partsTotal)}}</td>
                            <td>{{item.appointDate}}</td>
                            <td>{{item.jobPause}}</td>
                            <td>{{item.jobPauseRemark}}</td>
                            <td>{{item.insApproveDate}}</td>
                            <td>{{item.insSubmitDate}}</td>
                            <td>{{item.waitInsuranceCount}}</td>
                            <td>{{item.waitParts}}</td>
                            <td>{{item.serviceDetailCode == '0' ? '1' : displayEmpName(item.knock, item.waitStatus && item.serviceDetailCode == '1')}}</td>
                            <td>{{displayBeginDate(item.knock)}}</td>
                            <td>{{displayBeginTime(item.knock)}}</td>
                            <td>{{displayEndDate(item.knock)}}</td>
                            <td>{{displayEndTime(item.knock)}}</td>

                            <td>{{displayEmpName(item.prepareGround, item.waitStatus && item.serviceDetailCode == '2')}}</td>
                            <td>{{displayBeginDate(item.prepareGround)}}</td>
                            <td>{{displayBeginTime(item.prepareGround)}}</td>
                            <td>{{displayEndDate(item.prepareGround)}}</td>
                            <td>{{displayEndTime(item.prepareGround)}}</td>
<!--
                            <td>{{displayEmpName(item.mixColor, item.waitStatus && item.serviceDetailCode == '3')}}</td>
                            <td>{{displayBeginDate(item.mixColor)}}</td>
                            <td>{{displayBeginTime(item.mixColor)}}</td>
                            <td>{{displayEndDate(item.mixColor)}}</td>
                            <td>{{displayEndTime(item.mixColor)}}</td>
-->
                            <td>{{displayEmpName(item.sprayPaint, item.waitStatus && item.serviceDetailCode == '4')}}</td>
                            <td>{{displayBeginDate(item.sprayPaint)}}</td>
                            <td>{{displayBeginTime(item.sprayPaint)}}</td>
                            <td>{{displayEndDate(item.sprayPaint)}}</td>
                            <td>{{displayEndTime(item.sprayPaint)}}</td>

                            <td>{{displayEmpName(item.assemble, item.waitStatus && item.serviceDetailCode == '5')}}</td>
                            <td>{{displayBeginDate(item.assemble)}}</td>
                            <td>{{displayBeginTime(item.assemble)}}</td>
                            <td>{{displayEndDate(item.assemble)}}</td>
                            <td>{{displayEndTime(item.assemble)}}</td>

                            <td>{{displayEmpName(item.wax, item.waitStatus && item.serviceDetailCode == '6')}}</td>
                            <td>{{displayBeginDate(item.wax)}}</td>
                            <td>{{displayBeginTime(item.wax)}}</td>
                            <td>{{displayEndDate(item.wax)}}</td>
                            <td>{{displayEndTime(item.wax)}}</td>

                            <td>{{displayEmpName(item.clean, item.waitStatus && item.serviceDetailCode == '7')}}</td>
                            <td>{{displayBeginDate(item.clean)}}</td>
                            <td>{{displayBeginTime(item.clean)}}</td>
                            <td>{{displayEndDate(item.clean)}}</td>
                            <td>{{displayEndTime(item.clean)}}</td>

                            <td>{{displayEmpName(item.check, item.waitStatus && item.serviceDetailCode == '8')}}</td>
                            <td>{{displayBeginDate(item.check)}}</td>
                            <td>{{displayBeginTime(item.check)}}</td>
                            <td>{{displayEndDate(item.check)}}</td>
                            <td>{{displayEndTime(item.check)}}</td>
                            <td>{{item.remark}}</td>
                        </tr>
                    </tbody>
                </template>

               
            </v-data-table>
         </template>
        </v-card>
    </v-container>
</template>
<style scoped>
    .vertical-text {
        writing-mode: vertical-rl;
        text-orientation: mixed;
    }
    .border {
        border: black;
        border-style: solid;
        border-width: 1px;
    }
    .border-body {
        border: black;
        border-style: solid;
        border-width: 0px 0px 1px 1px;
    }
    .border-close {
        border: black;
        border-style: solid;
        border-width: 0px 1px 1px 1px;
    }

    td {
        white-space: nowrap;
    }
</style>
<script>
import {listControllerReport, exportControllerReport} from '@/api/reports/report-api.js'
import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import DatePicker from '@/components/Shared/DatePicker'
import numeral from 'numeral'

export default {
    name: 'controllerReport',
    components: {
        UserBranchDropdown,
        DatePicker
    },
    computed: {
        hideBtnReport() {
            console.log(this.isOnCreateReport);
            return this.isOnCreateReport;
        }
    },
   props:["pageCode"],
    data: () => ({
        carStatusItems: [
            {text: "ทั้งหมด", value: ""},
            {text: "รถจอด", value: "Y"},
            {text: "รถไม่จอด", value: "N"}
        ],
        carStatus: '',
        branchCode: '',
        sum: {
            carNotPresent: 0,
            jobPause: 0,
            waitInsurance: 0,
            waitParts: 0,
            waitKnock: 0,
            waitPrepareGround: 0,
        },
        sumDefault: {
            carNotPresent: 0,
            jobPause: 0,
            waitInsurance: 0,
            waitParts: 0,
            waitKnock: 0,
            knock: 0,
            waitPrepareGround: 0,
            prepareGround: 0,
            waitMixColor: 0,
            mixColor: 0,
            waitSprayPaint: 0,
            sprayPaint: 0,
            waitAssemble: 0,
            assemble: 0,
            waitWax: 0,
            wax: 0,
            waitClean: 0,
            clean: 0,
            waitCheck: 0,
            check: 0
        },
        items: [],
        isOnCreateReport : false
    }),
    methods: {
            setDateFrom(val) {
                  this.dateFrom = val;
            },
            setDateTo(val) {
                  this.dateTo = val;
            },
            setCurrentBranch(branchCode) {
                this.branchCode = branchCode;
                if (!this.branchCode) return;
               // this.search();
            },
            setCurrentBranchName(branchName) {
                this.branchName = branchName;
            },
            search(){
                this.$loading(true);
                listControllerReport(this.branchCode, this.carStatus).then(rs => {
                    this.$loading(false);
                    this.items = rs;
                    if (!this.items || this.items.length <= 0) return;
                    this.sum = Object.assign({}, this.sumDefault);
                        this.items.forEach(item => {
                            if (item.carNotPresent == true) this.sum.carNotPresent++;
                            if (item.jobPause == '1') this.sum.jobPause++;
                            if (item.waitInsuranceCount == '1') this.sum.waitInsurance++;
                            if (item.waitParts == '1') this.sum.waitParts++;

                            if (item.serviceDetailCode == '0') {
                                this.sum.waitKnock++; 
                            }

                            if (item.waitStatus == true) {
                                switch (item.serviceDetailCode) {
                                    case '2' : this.sum.waitPrepareGround++; break;
                                    case '3' : this.sum.waitMixColor++; break;
                                    case '4' : this.sum.waitSprayPaint++; break;
                                    case '5' : this.sum.waitAssemble++; break;
                                    case '6' : this.sum.waitWax++; break;
                                    case '7' : this.sum.waitClean++; break;
                                    case '8' : this.sum.waitCheck++; break;
                                }
                            }

                            if (item.knock && !item.knock.endDate)  this.sum.knock++;
                            if (item.prepareGround && !item.prepareGround.endDate) this.sum.prepareGround++;
                            if (item.sprayPaint && !item.sprayPaint.endDate) this.sum.sprayPaint++;
                            if (item.mixColor && !item.mixColor.endDate) this.sum.mixColor++;
                            if (item.assemble && !item.assemble.endDate) this.sum.assemble++;
                            if (item.wax && !item.wax.endDate) this.sum.wax++;
                            if (item.clean && !item.clean.endDate) this.sum.clean++;
                            if (item.check && !item.check.endDate) this.sum.check++;
                        });
                        
                }).catch(()=> {
                    this.$loading(false);
                });
            },
            createReport(){
                this.isOnCreateReport = true;
                 this.$loading(true);
                exportControllerReport(this.branchCode,this.branchName,this.dateFrom);
                this.isOnCreateReport = false;
                this.$loading(false);
            },
            numberFormat(val) {
                return numeral(val).format('0,0.00');
            },
            displayEmpName(item, isWait) {
                return item ? item.empName : isWait ? '1': '';
            },
            displayBeginDate(item) {
                return item ? item.beginDate : '';
            },
            displayBeginTime(item) {
                return item ? item.beginTime : '';
            },
            displayEndDate(item) {
                return item ? item.endDate : '';
            },
            displayEndTime(item) {
                return item ? item.endTime : '';
            },
            displayCarNotPresent(val) {
                return val ? '1' : '';
            }
    }
}
</script>